export default {
  appTitle: 'Clinic Admin Portal - by Limbic',
  appEnv: process.env.REACT_APP_APP_REAL_ENV,
  titanUrl: process.env.REACT_APP_TITAN_URL,
  titanApiKey: process.env.REACT_APP_TITAN_API_KEY_CLINIC_ADMIN_WEB_APP,
  authUrl: process.env.REACT_APP_AUTH_URL,
  logoUrl: process.env.REACT_APP_LOGO_URL,
  sentry: {
    dsn: process.env.REACT_APP_SENTRY_DSN,
  },
  appVersion: process.env.REACT_APP_VERSION,
};
